var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_1591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8707 5.19905C19.8707 2.80343 17.9433 0.875244 15.5486 0.875244H4.39309C1.99844 0.875244 0.0710449 2.80343 0.0710449 5.19905V10.3993C0.0710449 12.7949 1.99844 14.7231 4.39309 14.7231H15.5486C17.9433 14.7231 19.8707 12.7949 19.8707 10.3993V5.19905ZM12.8036 8.0621L8.3647 10.5162C8.18948 10.633 8.01426 10.4577 8.01426 10.2824V5.25748C8.01426 5.02376 8.18948 4.9069 8.3647 5.02376L12.862 7.59467C13.0372 7.71153 13.0372 7.94524 12.8036 8.0621Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_1591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.98,
    height: 14.14,
    fill: "white",
    transform: "translate(0.0100021 0.699951)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.e2e5863c5a61b6791815336661648e44.svg";
export { ForwardRef as ReactComponent };